import CampusMapMarker from "./CampusMapMarker";

export default function CampusMapExperience({ campus, campusKey, selectedId, onSelect }) {
  const selectedFacility =
    campus.facilities.find((facility) => facility.id === selectedId) || campus.facilities[0];

  return (
    <section className="campus-map-experience">
      <div
        className={`campus-map-canvas campus-map-canvas--${campusKey}`}
        data-testid="campus-map-canvas"
      >
        <img
          alt={campus.imageAlt}
          className="campus-map-image"
          data-testid={`campus-map-image-${campusKey}`}
          src={campus.imageUrl}
        />
        <div aria-hidden="true" className="campus-map-shade" />
        {campus.facilities.map((facility) => (
          <CampusMapMarker
            facility={facility}
            isSelected={facility.id === selectedId}
            key={facility.id}
            onSelect={onSelect}
          />
        ))}
        <span className="campus-map-title">{campus.title}</span>
      </div>
      <aside className="campus-map-detail" data-testid="campus-map-detail">
        <span>{selectedFacility.type}</span>
        <h2>{selectedFacility.name}</h2>
        <p>{selectedFacility.detail}</p>
        <div className="campus-map-key">
          <strong>Campus intent</strong>
          <p>{campus.intro}</p>
        </div>
      </aside>
    </section>
  );
}